import Transformer from './../transformer'

export default class HighwayTollboothTransformer extends Transformer {
  static fetch(tollbooth) {
    return {
      id: tollbooth.id,
      name: tollbooth.name,
      // isActive: tollbooth.is_active,
      // s
      highwayId: tollbooth.highway.highway_id,
      highwayName: tollbooth.highway.highway_name,

      highwayCustomerId: tollbooth.highway.highway_cliente_id,
      highwayCustomerName: tollbooth.highway.highway_cliente,
      // s
      highwaySectionId: tollbooth.highway_section.id,
      highwaySectionName: tollbooth.highway_section.name,
      highwaySectionNumber: tollbooth.highway_section.highway_section_number,
      // s
      municipalityId: tollbooth.municipality.id,
      municipalityName: tollbooth.municipality.name,
      // s
      stateId: tollbooth.state.id,
      stateName: tollbooth.state.name,
      // s
      tollboothAttendantName: tollbooth.attendant.name + ' ' + tollbooth.attendant.last_name,
      tollboothAttendantId: tollbooth.attendant.attendant_id,
      //TODO: need client
    }
  }
  // TODO: Pending add client data 
  static send(tollbooth) {
    return {
      id: tollbooth.id,
      name: tollbooth.name,
      is_active: true,
      attendant: tollbooth.tollboothAttendantId,
      highway_section: tollbooth.highwaySectionId,
      state: tollbooth.stateId,
      municipality: tollbooth.municipalityId,
      highway: tollbooth.highwayId,
    }
  }
}


// WEBPACK FOOTER //
// ./src/transformers/catalog/highwayTollbooth.js